import React from 'react';
import { IconProps } from './types';

const NoCorporateNosIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
    >
      <path
        opacity="0.2"
        d="M111.18 158.274L145.03 147.884C145.98 147.594 145.91 146.214 144.93 146.024L101.82 137.594L111.17 158.274H111.18Z"
        fill="#7A7F88"
      />
      <path
        d="M147.3 164.193C148.94 164.193 150.26 162.863 150.26 161.233C150.26 159.603 148.93 158.273 147.3 158.273C145.67 158.273 144.34 159.603 144.34 161.233C144.34 162.863 145.67 164.193 147.3 164.193Z"
        fill="#ECECEC"
      />
      <path
        d="M26.9902 33.0037C29.1002 33.0037 30.8202 31.2937 30.8202 29.1737C30.8202 27.0538 29.1102 25.3438 26.9902 25.3438C24.8702 25.3438 23.1602 27.0538 23.1602 29.1737C23.1602 31.2937 24.8702 33.0037 26.9902 33.0037Z"
        fill="#ECECEC"
      />
      <path
        d="M20.0202 16.4934C21.4602 16.4934 22.6302 15.3234 22.6302 13.8834C22.6302 12.4434 21.4602 11.2734 20.0202 11.2734C18.5802 11.2734 17.4102 12.4434 17.4102 13.8834C17.4102 15.3234 18.5802 16.4934 20.0202 16.4934Z"
        fill="#ECECEC"
      />
      <path d="M19.7998 121.031H30.7998" stroke="#CACDCC" />
      <path d="M25.2998 126.531V115.531" stroke="#CACDCC" />
      <path d="M159.15 13.2422H170.15" stroke="#CACDCC" />
      <path d="M164.65 18.7422V7.74219" stroke="#CACDCC" />
      <path
        d="M136.91 31.6891L136.9 31.6791C136.48 31.3291 132.2 28.7491 131.68 28.5391L50.3601 149.699L55.1301 152.749C55.8601 153.219 57.2001 153.689 58.1301 153.789L107.35 159.259C110.48 159.609 113.37 157.519 114.02 154.439L138.72 36.9491C139.15 34.9091 138.37 32.9291 136.91 31.6991V31.6891Z"
        fill="#CACDCC"
        stroke="#A1A7A5"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.71 156.482L53.4904 151.012C50.0204 150.622 47.6504 147.332 48.3804 143.922L73.1504 28.1323C73.7604 25.3123 76.3604 23.3823 79.2304 23.6123L129.12 27.6523C132.42 27.9223 134.73 31.0223 134.05 34.2623L109.37 151.662C108.72 154.742 105.83 156.832 102.7 156.482H102.71Z"
        fill="#ECECEC"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeMiterlimit="10"
      />
      <path
        d="M131.84 34.1135L107.58 150.744C107.1 153.014 104.98 154.554 102.67 154.304L53.5503 148.864C51.1103 148.594 49.4403 146.274 49.9503 143.874L74.5103 28.6435C74.9903 26.3835 77.0803 24.8335 79.3803 25.0235L92.5803 26.0935C93.7303 26.1835 94.6703 27.0235 94.9003 28.1535C95.0603 28.9135 95.6903 29.4835 96.4703 29.5435L109.12 30.5935C109.79 30.6535 110.45 30.3835 110.89 29.8735L111.77 28.8535C112.39 28.1435 113.3 27.7635 114.24 27.8435L127.98 28.9635C130.56 29.1735 132.36 31.5935 131.83 34.1235L131.84 34.1135Z"
        fill="#FDFDFD"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeMiterlimit="10"
      />
      <path
        d="M122.08 47.582C123.91 47.742 125.05 49.502 124.63 51.512C124.21 53.522 122.38 55.022 120.54 54.862L77.6605 51.112C75.8305 50.952 74.6905 49.192 75.1105 47.182C75.5305 45.172 77.3605 43.672 79.2005 43.832L122.08 47.582Z"
        fill="white"
        stroke="#EAEAEA"
        strokeWidth="0.46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.7828 48.2286C81.1892 47.5838 81.0754 46.7818 80.5288 46.4373C79.9821 46.0928 79.2095 46.3362 78.8032 46.981C78.3968 47.6257 78.5105 48.4277 79.0572 48.7722C79.6039 49.1168 80.3765 48.8734 80.7828 48.2286Z"
        fill="#ECECEC"
      />
      <path
        d="M84.5211 48.5567C84.9275 47.9119 84.8137 47.1099 84.267 46.7654C83.7204 46.4209 82.9478 46.6643 82.5414 47.3091C82.1351 47.9539 82.2488 48.7559 82.7955 49.1004C83.3422 49.4449 84.1147 49.2015 84.5211 48.5567Z"
        fill="#ECECEC"
      />
      <path
        d="M88.2406 48.8692C88.6469 48.2244 88.5332 47.4224 87.9865 47.0779C87.4399 46.7334 86.6673 46.9768 86.2609 47.6216C85.8546 48.2664 85.9683 49.0684 86.515 49.4129C87.0616 49.7574 87.8342 49.514 88.2406 48.8692Z"
        fill="#ECECEC"
      />
      <path
        d="M118.781 49.4032C119.391 49.4532 119.781 50.0632 119.631 50.7332C119.481 51.4032 118.871 51.9132 118.261 51.8532C117.651 51.7932 117.261 51.2132 117.401 50.5332C117.541 49.8532 118.161 49.3432 118.771 49.4032H118.781Z"
        fill="white"
      />
      <path
        d="M119.341 51.565C119.401 51.565 119.461 51.595 119.491 51.645L119.591 51.795L120.261 52.805C120.341 52.905 120.301 53.085 120.181 53.185L119.991 53.245L119.831 53.155L119.151 52.145L119.061 52.005C118.991 51.895 119.021 51.725 119.141 51.625C119.201 51.575 119.271 51.555 119.331 51.565H119.341Z"
        fill="#ECECEC"
      />
      <path
        d="M118.9 48.8731C119.78 48.9531 120.34 49.8031 120.13 50.7831C120.05 51.1731 119.86 51.5231 119.6 51.8031L119.5 51.6531C119.46 51.6031 119.41 51.5731 119.35 51.5731C119.29 51.5731 119.22 51.5931 119.16 51.6331C119.04 51.7331 119.01 51.9031 119.08 52.0131L119.17 52.1531C118.86 52.3431 118.51 52.4331 118.16 52.4031C117.28 52.3231 116.72 51.4731 116.93 50.5031C117.14 49.5331 118.02 48.7931 118.9 48.8731ZM118.27 51.8631C118.88 51.9131 119.5 51.4131 119.64 50.7431C119.78 50.0731 119.4 49.4631 118.79 49.4131C118.18 49.3631 117.56 49.8731 117.42 50.5431C117.28 51.2131 117.66 51.8031 118.28 51.8631"
        fill="#ECECEC"
      />
      <g opacity="0.5">
        <path
          d="M81.6904 60.6308C82.7504 60.7408 83.4004 61.7708 83.1404 62.9208L81.7604 69.0608C81.5004 70.2108 80.4304 71.0708 79.3604 70.9608L73.7104 70.3708C72.6504 70.2608 72.0004 69.2208 72.2604 68.0708L73.6404 61.9308C73.9004 60.7808 74.9704 59.9308 76.0304 60.0408L81.6804 60.6308H81.6904Z"
          fill="#ECECEC"
        />
        <path
          d="M99.9804 62.5527C101.04 62.6627 101.69 63.6927 101.43 64.8427L100.05 70.9827C99.7904 72.1327 98.7204 72.9927 97.6504 72.8827L92.0004 72.2927C90.9404 72.1827 90.2904 71.1427 90.5504 69.9927L91.9304 63.8527C92.1904 62.7027 93.2604 61.8527 94.3204 61.9627L99.9704 62.5527H99.9804Z"
          fill="#ECECEC"
        />
        <path
          d="M118.27 64.4746C119.33 64.5846 119.99 65.6146 119.73 66.7646L118.35 72.9046C118.09 74.0546 117.01 74.9146 115.94 74.8046L110.29 74.2146C109.23 74.1046 108.58 73.0646 108.84 71.9146L110.22 65.7746C110.48 64.6246 111.55 63.7746 112.61 63.8846L118.26 64.4746H118.27Z"
          fill="#ECECEC"
        />
        <path
          d="M76.98 81.5683C78.04 81.6783 78.69 82.7083 78.43 83.8583L77.05 89.9983C76.79 91.1483 75.72 91.9983 74.66 91.8883L69.01 91.2983C67.95 91.1883 67.3 90.1583 67.56 89.0083L68.94 82.8683C69.2 81.7183 70.27 80.8683 71.33 80.9783L76.98 81.5683Z"
          fill="#ECECEC"
        />
        <path
          d="M95.27 83.4902C96.33 83.6002 96.98 84.6302 96.72 85.7802L95.34 91.9202C95.08 93.0702 94.01 93.9202 92.95 93.8102L87.3 93.2202C86.24 93.1102 85.59 92.0802 85.85 90.9302L87.23 84.7902C87.49 83.6402 88.56 82.7902 89.62 82.9002L95.27 83.4902Z"
          fill="#ECECEC"
        />
        <path
          d="M113.56 85.4143C114.62 85.5243 115.28 86.5543 115.02 87.7043L113.64 93.8443C113.38 94.9943 112.3 95.8443 111.24 95.7243L105.59 95.1343C104.53 95.0243 103.88 93.9943 104.14 92.8443L105.52 86.7043C105.78 85.5543 106.85 84.7043 107.91 84.8143L113.56 85.4043V85.4143Z"
          fill="#ECECEC"
        />
        <path
          d="M72.28 102.498C73.34 102.608 73.99 103.638 73.73 104.788L72.35 110.928C72.09 112.078 71.02 112.928 69.96 112.818L64.31 112.228C63.25 112.118 62.6 111.088 62.86 109.938L64.24 103.798C64.5 102.648 65.57 101.798 66.63 101.908L72.28 102.498Z"
          fill="#ECECEC"
        />
        <path
          d="M90.56 104.42C91.62 104.53 92.27 105.56 92.01 106.71L90.63 112.85C90.37 114 89.3 114.85 88.24 114.74L82.59 114.15C81.53 114.04 80.88 113.01 81.14 111.86L82.52 105.72C82.78 104.57 83.85 103.72 84.91 103.83L90.56 104.42Z"
          fill="#ECECEC"
        />
        <path
          d="M108.85 106.344C109.91 106.454 110.57 107.484 110.31 108.634L108.93 114.774C108.67 115.924 107.59 116.774 106.53 116.654L100.88 116.064C99.8203 115.954 99.1703 114.924 99.4303 113.774L100.81 107.634C101.07 106.484 102.14 105.634 103.2 105.744L108.85 106.334V106.344Z"
          fill="#ECECEC"
        />
        <path
          d="M67.57 123.428C68.63 123.538 69.28 124.578 69.02 125.728L67.64 131.868C67.38 133.018 66.31 133.868 65.25 133.758L59.6 133.168C58.54 133.058 57.89 132.028 58.15 130.878L59.53 124.738C59.79 123.588 60.86 122.728 61.93 122.838L67.58 123.428H67.57Z"
          fill="#ECECEC"
        />
        <path
          d="M85.8601 125.349C86.9201 125.459 87.5701 126.499 87.3101 127.649L85.9301 133.789C85.6701 134.939 84.6001 135.789 83.5401 135.679L77.8901 135.089C76.8301 134.979 76.1801 133.949 76.4401 132.799L77.8201 126.659C78.0801 125.509 79.1501 124.649 80.2201 124.759L85.8701 125.349H85.8601Z"
          fill="#ECECEC"
        />
        <path
          d="M104.14 127.274C105.2 127.384 105.86 128.424 105.6 129.574L104.22 135.714C103.96 136.864 102.88 137.714 101.82 137.594L96.1703 137.004C95.1103 136.894 94.4604 135.864 94.7204 134.714L96.1003 128.574C96.3603 127.424 97.4304 126.564 98.5004 126.674L104.15 127.264L104.14 127.274Z"
          fill="#ECECEC"
        />
      </g>
      <path d="M80.4301 142.586L82.0201 144.606L79.6201 146.216L80.4301 142.586Z" fill="#ECECEC" />
      <path d="M77.7906 142.305L76.9706 145.935L75.3906 143.905L77.7906 142.305Z" fill="#ECECEC" />
      <path
        d="M143.57 81.5294C145.21 81.5294 146.53 80.1994 146.53 78.5694C146.53 76.9394 145.2 75.6094 143.57 75.6094C141.94 75.6094 140.61 76.9394 140.61 78.5694C140.61 80.1994 141.94 81.5294 143.57 81.5294Z"
        fill="#ECECEC"
      />
      <path
        opacity="0.2"
        d="M103.65 82.455L99.2502 102.875C99.0902 103.635 98.3502 104.185 97.6102 104.105L57.6602 99.585L64.6002 67.125L94.9602 70.565C95.4802 70.625 95.9402 70.885 96.2302 71.305L103.46 81.415C103.66 81.705 103.73 82.075 103.65 82.455Z"
        fill="#7A7F88"
      />
      <path
        d="M95.2588 99.1865L44.3488 93.4265C43.6088 93.3465 43.1388 92.6565 43.2988 91.8965L49.6988 62.2065C49.8588 61.4465 50.5988 60.8965 51.3388 60.9765L92.5988 65.6465C93.1188 65.7065 93.5788 65.9665 93.8788 66.3865L101.099 76.4965C101.309 76.7865 101.379 77.1565 101.299 77.5365L96.8988 97.9565C96.7388 98.7165 95.9988 99.2665 95.2588 99.1865Z"
        fill="#A1A7A5"
      />
      <path
        d="M94.4893 98.4365L43.5793 92.6765C42.8393 92.5965 42.3693 91.9065 42.5293 91.1465L48.9293 61.4565C49.0893 60.6965 49.8293 60.1465 50.5693 60.2265L91.8293 64.8965C92.3493 64.9565 92.8093 65.2165 93.1093 65.6365L100.329 75.7465C100.539 76.0365 100.609 76.4065 100.529 76.7865L96.1293 97.2065C95.9693 97.9665 95.2293 98.5165 94.4893 98.4365Z"
        fill="white"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.5193 89.5202L54.0593 87.2102C52.4393 87.0302 51.4193 85.5402 51.7793 83.8802L54.6793 70.4302C55.0393 68.7702 56.6393 67.5802 58.2593 67.7602L78.7193 70.0702C80.3393 70.2502 81.3593 71.7402 80.9993 73.4002L78.0993 86.8502C77.7393 88.5102 76.1393 89.7002 74.5193 89.5202Z"
        fill="#CACDCC"
        stroke="#A1A7A5"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.5689 80.7959L59.1689 83.2659L52.1289 82.4659L54.4189 71.8359L61.4789 72.6359L63.6689 75.7359L62.5689 80.7959Z"
        fill="#CACDCC"
        stroke="#A1A7A5"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.2693 77.1562L63.0593 78.2662"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.1396 81.5378L71.3396 84.6478L78.3796 85.4378L80.6796 74.8078L73.6197 74.0078L70.2297 76.4878L69.1396 81.5378Z"
        fill="#CACDCC"
        stroke="#A1A7A5"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M79.5293 80.1256L69.7393 79.0156"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.4791 68.9141L64.2891 88.3641"
        stroke="#A1A7A5"
        strokeWidth="0.46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.1093 81.5344L62.5693 80.7944L63.6593 75.7344L70.1993 76.4744L69.1093 81.5344Z"
        fill="#CACDCC"
        stroke="#A1A7A5"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoCorporateNosIcon;
